<template>
  <div
    class="
      max-w-screen-md
      h-screen
      mx-auto
      flex flex-col
      items-center
      justify-center
    "
  >
    <div class="w-1/2 md:w-1/3 mx-auto">
      <Lottie :animationData="animationData" />
    </div>

    <h2 class="text-3xl mb-5 text-center px-2">Uh oh! Something went wrong</h2>
    <p class="py-1 text-center px-2">
      Please refresh the page or return to the dashboard
    </p>
    <router-link
      :to="{ name: 'dashboard_forms' }"
      class="py-1 text-brand-green cursor-pointer"
      >Go to the dashboard</router-link
    >
  </div>
</template>
<script>
import ServerError from "@/assets/animations/500.json"

export default {
  data() {
    return {
      animationData: ServerError
    }
  }
}
</script>
